module.exports = __webpack_public_path__ + "static/007.thumb-105f58f41b99184906039e7b685b7f84.jpg";